import styled from 'styled-components'

import { Span } from '@/@bothrs-ui/web/components/typography/Body'

export const StObservationItem = styled(Span)`
  padding: ${({ theme }) => theme.UI.SpacingPx.Space3}
    ${({ theme }) => theme.UI.SpacingPx.Space4};
  background-color: ${({ theme }) => theme.Colors.Neutrals.Lighter};
`
